module.exports = __webpack_public_path__ + "img/is-safe-section-4.1f8896cb.png";